/**
 * Catálogo central de efectos de partículas (v2).
 *
 * Los datos viven en `particleEffects.json` para que el endpoint dev
 * (`POST /__dev/particles/save`) pueda persistir sin parsear TypeScript.
 * Este wrapper sólo aporta tipado y helpers.
 *
 * Flujo recomendado para crear/editar FX: botón ✨ del index pre-login.
 *
 * Convención de IDs (en inglés, snake_case):
 *   fx_<categoría>_<descripción>_<variante?>
 *
 * Categorías esperadas:
 *   - aura       (loops sobre entidad: meditate, regen, escudo)
 *   - projectile (caster → target con trail)
 *   - impact     (burst one-shot al llegar)
 *   - overlay    (sobre items equipados: armor flames, weapon trail)
 *   - drop       (sobre items en el piso)
 *   - env        (sobre tiles: niebla, hojas, fireflies)
 *   - cast       (mientras se castea: anillo en pies, símbolos sobre cabeza)
 */

import type { ParticleEffectDefV2 } from '../types/particles';
import rawData from './particleEffects.json';

// El cast pasa por `unknown` porque el JSON tiene tipos literales (números
// estrechos en frames, frameScales como objeto con keys numéricas, etc.) que
// no overlapan estrictamente con la interface `ParticleEffectDefV2`. A
// runtime el shape es correcto; el cast saltea la verificación overlap.
export const PARTICLE_EFFECTS: Record<string, ParticleEffectDefV2> =
  rawData as unknown as Record<string, ParticleEffectDefV2>;

/** Helper para tipado en consumers. */
export type ParticleEffectId = string;

/** Lookup seguro: undefined si el id no existe en el catálogo. */
export function getParticleEffect(id: string): ParticleEffectDefV2 | undefined {
  return PARTICLE_EFFECTS[id];
}

/** Lista de todos los ids disponibles. */
export function listParticleEffectIds(): string[] {
  return Object.keys(PARTICLE_EFFECTS);
}
